module.exports = __webpack_public_path__ + "img/hospital2.91310248.png";